<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
      
         <z-page title="Penyediaan Penyata Pemungut Ibayaq">
          <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="submitPemugut">
            <div class="message-box">
              <w-transition-fade>
                <w-alert
                  class="my0 text-light"
                  v-if="form.submitted"
                  success
                  no-border>
                  The form is valid, ready to send it!
                </w-alert>

                <w-alert
                  class="my0 text-light"
                  v-else-if="form.valid === false"
                  error
                  no-border>
                  Terdapat {{ form.errorsCount }} ralat di dalam borang ini.
                </w-alert>
              </w-transition-fade>
            </div>

                 <!-- <w-flex justify-space-between class="mb4">
                    <div class="xs4">
                          <h5 class="fw-semibold m0">
                              Tarikh :
                          </h5>
                          <div class="fw-normal my1 fs-1">{{date('DD-MM-YYYY')}} </div>
                    </div>
                 </w-flex> -->
                 <w-flex justify-space-between class="mb4"> 
                    <div class="xs4"> 
                         <!-- <z-lookup
                            label="Bank *" 
                            name="bank"
                            :url="
                                service_utiliti +
                                'lookup/tambah_bank'
                            "
                            :sort="false"
                            :cache="false"
                            v-model="form.bank"
                            :validators="[
                                validators.required,
                            ]"
                        /> -->
                        <w-select 
                            :items="banks" 
                            label="Bank *" 
                            v-model="form.bank"
                            :sort="false"
                            :cache="false"
                             @input="getBankakaun()"
                             :validators="[
                                validators.required,
                            ]"
                           
                            />
                    </div>
                </w-flex>
                <w-flex justify-space-between class="mb4"> 
                    <div class="xs4"> 
                         <w-select 
                            :items="bank_akaun" 
                            label="No. Akaun"  
                            v-model="form.bank"
                             @input="getBankakaunketerangan()"
                            />
                    </div>
                </w-flex> 
                <w-flex justify-space-between class="mb4">
                    <div class="xs4"> 
                        <z-input 
                          label="Keterangan" 
                          name="bank_akaun_keterangan" 
                          v-model="form.bank_akaun_keterangan" 
                           readonly/>
                      </div>
                </w-flex>

                <!--  <w-flex justify-space-between class="mb4">
                    <div class="xs4"> 
                        <z-input 
                          label="No. Akaun *"  
                          name="no_slip_bank" 
                          v-model="form.no_akaun"
                          :validators="[validators.required,]" 
                          />
                      </div>
                </w-flex>  -->
                <w-flex justify-space-between class="mb4">
                    <div class="xs4"> 
                        <z-input 
                          label="Tarikh Slip Bank" 
                          name="tarikh_slip_bank" 
                          v-model="form.tarikh_slip_bank" 
                           type="date"/>
                      </div>
                </w-flex>
                 <w-flex justify-space-between class="mb4">
                    <div class="xs4"> 
                        <z-input 
                          label="No. Slip Bank"  
                          name="no_slip_bank" 
                          v-model="form.no_slip_bank"
                          
                          />
                      </div>
                </w-flex> 
                <br>

                 <w-flex justify-center align-center class="mt5">

              <div class="w-card__content content-hardcode">    
              <w-flex justify-space-between class="mb4">
                    <div class="xs4"> 
                        <z-input 
                          label="Tarikh bayar"  
                          name="no_slip_bank" 
                          v-model="form.tarikh_bayar"
                          type="date"
                          />

                      </div>
                      <div class="xs4" style="margin-top: 10px"> 
                          <w-button  :loading="form.submitted " @click="Resit()">
                        <w-icon dark tile class="mr2">fal fa-search</w-icon> Cari
                    </w-button>
                  </div>
                  <div class="xs4"> 
                  </div>

                </w-flex>             
                <table class="table-dashboard" width="100%">
                    <thead>
                        <tr>
                            <!-- <td>Tarikh</td> -->
                            <td>Kaunter</td>
                            <td>Cara Bayar</td>
                            <td>Amaun (RM)</td>
                            <td>  <w-checkbox
                                        v-model="pilih"
                                        @click="cekPilih"
                                    ></w-checkbox></td>
                        </tr>
                    </thead>
                    <tbody v-if="form.resit.length > 0">
                        <tr v-for="(dt, index) in form.resit">
                                <td>{{ dt.kod }}</td>
                                <td>{{dt.keterangan}}</td>
                                <td align="right">
                                    {{ $zutil.currency(dt.total) }}
                                </td>
                                <td>
                                     <w-checkbox
                                        v-model="dt.pilih"
                                    ></w-checkbox>
                                </td>
                            </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="8" align="center">Tiada Rekod</td>
                      </tr>
                    </tbody>
                </table>
              </div>

            </w-flex>
             <w-flex class="mt3" wrap align-center justify-end>
                <div class="spacer" />
                <template v-if="$zutil.can('Penyata Pemungut Penyediaan')">
                  <template v-if="form.submitted == true">
                    <w-button class="my1"  :loading="form.submitted ">
                        <w-icon dark tile class="mr2">fal fa-save</w-icon> Jana Penyata Pemungut
                    </w-button>
                  </template>
                  <template v-else>
                    <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted ">
                        <w-icon dark tile class="mr2">fal fa-save</w-icon> Jana Penyata Pemungut
                    </w-button>
                  </template>
                    
                </template>

            </w-flex>

          </w-form>
      </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'
// import moment from 'moment'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {

        resourceurl: this.service_kutipan+'penyata_pemungut',
        reload: true,
        form:{
            resit: [],
            cek : null,
            bank : null,
        },
        pilih: false,
        bank_akaun: [],
        banks: [],
        
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Penyata Pemungut', route: 'kutipan/penyata_pemungut/index' },
            { label: 'Daftar Ibayaq', route: 'kutipan/penyata_pemungut/daftar' }
          ],
          }
  },
  methods: {

    cekPilih() {
            for (var i in this.form.resit) {
                this.form.resit[i].pilih = this.pilih;
            }
            
        },

     Resit() {
      if(this.form.tarikh_bayar){
        this.form.submitted = 1
               this.$zcomm
                .get(
                        this.service_kutipan + "resit_ibayaq?tarikh_bayar="+this.form.tarikh_bayar
                )
                .then((res) => {
                    console.log(res);
                    this.form.submitted = null
                        // this.form.resit_id = res.resit.id;
                        
                          this.form.resit = res;
                          this.form.kaunter_id = res.kaunter_id;
                          this.form.cara_bayaran = res.cara_bayaran;
                        
                        // this.form.cara_bayaran = res.data.cara_bayaran;
                        
                });
              }

        },

   
    submitPemugut(){
     if(this.form.valid == true){
      this.form.submitted = true
      this.form.lkp_sumber_id = 2
        this.$zcomm.post(this.resourceurl, this.form)
          .then(res => {
                          if (typeof this.onAfterAdd === "function") {
                              this.onAfterAdd()
                          }
                          this.$zutil.notify ("Rekod telah berjaya dihantar")
                          this.$inertia.visit(this.$route('kutipan.pemungut.senarai_ibayaq'))

                        })
                        .catch(err => {

                        })
                        .finally(() => {

                        });
     }
              
    },

    getBankakaunbaru() { 
        
        this.$zcomm.get(this.service_utiliti+'lookup/bank_default_ibayaq').then(res => {
                  this.form.bank = res.value;
        this.getBanks();
        this.getBankakaun(this.form.bank);

                }); 
        

        },

    getBanks() { 
        
        this.$zcomm.get(this.service_utiliti+'lookup/tambah_bank').then(res => {
                  this.banks = res;  
                  // this.form.bank = res.value;

        // alert(this.form.bank);
                }); 
        

        },

    getBankakaun() { 
        
        // alert(this.form.bank);
        this.$zcomm.get(this.service_utiliti+'lookup/bank_akaun/'+this.form.bank).then(res => {
                  this.bank_akaun = res;

                this.getBankakaunketerangan();
                });
       
        },

        getBankakaunketerangan() { 
        
        // alert(this.form.bank);
        this.$zcomm.get(this.service_utiliti+'lookup/bank_akaun_keterangan/'+this.form.bank).then(res => {
                  this.form.bank_akaun_keterangan = res.keterangan;
                  // alert(this.form.bank_akaun_keterangan);
                });
       
        },


    
    
    
  
    
  },
  watch: {
   
    
  },
  mounted() {
    this.getBankakaunbaru();
    // this.Resit()
    
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
